import { Component, OnInit } from '@angular/core';
import {
	Data, Subscription, DataLoaderService, CommonDataService, PriceCalculationService,
	AlternateOptionsService, ProgressBarService,
	SummaryService, SortingService
} from '../service-call-index';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
import {ExpertValidation } from '../../expert-screen-components/expert-validation/expert-validation.component'
import { SummaryValidationComponent} from './../summary-validations/summary-validations.component'
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
@Component({
	selector: 'package-options',
	templateUrl: './package-options.template.html',
	styleUrls: ['./package-options.component.css'],
})
export class PackageOptions implements OnInit {
	private subscription: Subscription;
	private packageOptions: Data[];
	private localPackageOptions: Data[];
	private lengthOfPackageOptions; lengthOfLocalPackageOptions: number;
	private selectedPackageOptions: Data[] = [];
	private selectedLocalPackageOptions: Data[] = [];
	private flag: boolean = false;
	private packageDataSuggList = [];
	private localPackageDataSuggList = [];
	private packageInitialState: any;
	private localPackageInitialState: any;
	private currency; errMessage: string;
	private hideViewDetails: boolean = false;
	private hideLocalViewDetails: boolean = false;
	public vehicleInfo: any;
	// for sorting
	private allPackageOptions:Data[];
	
	//private item = [];
	public icon: string = "gray";
	constructor(private dataLoaderService: DataLoaderService, private sortingService: SortingService,
		private priceCalculationService: PriceCalculationService, private progressService: ProgressBarService, private summaryService: SummaryService, private expertValidation: ExpertValidation,
		private summaryValidationComponent: SummaryValidationComponent, private alternateScreenComponent: AlternateScreenComponent,
		private alternateOptionsService: AlternateOptionsService, private vehicleInfoService: VehicleInfoService,
		private commonDataService: CommonDataService) {
		this.vehicleInfo = this.vehicleInfoService.extractData();
		this.packageOptions = this.dataLoaderService.data.packages;
		this.localPackageOptions = this.dataLoaderService.data.localPackagesList;
		this.currency = this.dataLoaderService.data.currencyType;
		// for sorting
		this.allPackageOptions = this.localPackageOptions.concat(this.packageOptions);
		this.sortingService.sortChecked(this.allPackageOptions)
	}
    /**
     * Package Options are loaded on initialisation
     * @param none
     * @returns none
     */
	ngOnInit() {
		this.commonDataService.notifyObservableAllPackageOptions$.subscribe((allPackages) =>{
			this.allPackageOptions = allPackages;
			this.sortingService.sortChecked(this.allPackageOptions)
		})
		this.summaryService.getSelectedOptions();

		//retention service
		this.subscription = this.priceCalculationService.notifyObservableExpertComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertPackage") {
				this.selectedPackageOptions = [];
				for (let i in selectedOption.data[0]) {
					for (let j in this.packageOptions) {
						if (this.packageOptions[j].code === selectedOption.data[0][i].code) {
							// this.packageOptions[j].selected = true;
							this.selectedPackageOptions.unshift(selectedOption.data[0][i]);
						}
					}
				}
			}
		});
		this.subscription = this.priceCalculationService.notifyObservableExpertComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "expertLocalPackage") {
				this.selectedLocalPackageOptions = [];
				for (let i in selectedOption.data[0]) {
					for (let j in this.localPackageOptions) {
						if (this.localPackageOptions[j].code === selectedOption.data[0][i].code) {
							//  this.localPackageOptions[j].selected = true;
							this.selectedLocalPackageOptions.unshift(selectedOption.data[0][i]);
						}
					}
				}
			}
		});

		//fetching length for displaying in HTML
		this.lengthOfPackageOptions = this.dataLoaderService.data.packages.length;
		this.lengthOfLocalPackageOptions = this.dataLoaderService.data.localPackagesList.length;

		//Calculate price
		// this.calculateTotalPrice();
		this.packageOptions.forEach(element => {
			if (element.selected === true) {
				this.selectedPackageOptions.unshift(element);
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedPackageOptions] });
			}
		});

		this.localPackageOptions.forEach(element => {
			if (element.selected === true) {
				this.selectedLocalPackageOptions.unshift(element);
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.selectedLocalPackageOptions] });
			}
		});
		
		// this.priceCalculationService.normalModePriceCalculation();
			
	}
	// calculateTotalPrice(){
	// 	this.packageOptions.forEach(element => {
	// 		if (element.selected === true) {
	// 			this.selectedPackageOptions.unshift(element);
	// 			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedPackageOptions] });
	// 		}
	// 	});

	// 	this.localPackageOptions.forEach(element => {
	// 		if (element.selected === true) {
	// 			this.selectedLocalPackageOptions.unshift(element);
	// 			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.selectedLocalPackageOptions] });
	// 		}
	// 	});
	// }
    /**
     * To select a package option and populating the selected option in an array 
     * @param item of Data type
     * @returns none
     */
	selectPackageOption(item) {
		setTimeout(() => {
			this.progressService.illuminateRed();
		}, 0);
		this.dataLoaderService.flagDictionary.validated = false;
		this.commonDataService.item.push(item);
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetPackageOptionsFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;

		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.packageDataSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.packageDataSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.dataLoaderService.flagDictionary.validated = true;
					}
					else {
						for (let i in this.packageOptions) {
							if (this.packageOptions[i].code === item.code) {
								this.packageOptions[i].selected = true;
								this.alternateScreenComponent.updatedPrices();
							}
						}
						this.flag = this.packageCheck(item);
						if (this.flag) {
							this.dataLoaderService.flagDictionary.validated = false;
							this.selectedPackageOptions.unshift(item);
						}
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.dataLoaderService.flagDictionary.validated = true;	
						if(item.packagedEquipmentList === null || this.dataLoaderService.flagDictionary.alternateValidateFlag === false){
							this.commonDataService.progressBarColorFlag = true;
							if(this.commonDataService.progressBarColorFlag == true){
								setTimeout(() => {
								this.progressService.illuminateGreen();								
								}, 0);
							}
						}
						if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
							setTimeout(() => {
								this.progressService.illuminateGreen();
							}, 0);
						}

						this.savePackage();
					}
					this.sortingService.sortCodes(this.packageOptions,true)
					// for sorting
					this.sortingService.sortChecked(this.allPackageOptions)
                
					
				}, err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.packageOptions) {
				if (this.packageOptions[i].code === item.code) {
					this.packageOptions[i].selected = true;
				}
			}
			this.flag = this.packageCheck(item);
			if (this.flag) {
				this.selectedPackageOptions.unshift(item);
			}
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.packageOptions,true)
			// for sorting
			this.sortingService.sortChecked(this.allPackageOptions)
			this.savePackage();
		}
		this.progressService.progressBarValidation();
	}


	/**
	 * To select a local package option and populating the selected option in an array 
	 * @param item of Data type
	 * @returns none
	 */

	selectLocalPackageOption(item) {
			setTimeout(() => {
				this.progressService.illuminateRed();
			}, 0);
			this.dataLoaderService.flagDictionary.validated=false;
		this.commonDataService.deselectValue.push(item);
		this.commonDataService.item.push(item);
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
		this.progressService.illuminateYellow();
		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.localPackageDataSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.localPackageDataSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.dataLoaderService.flagDictionary.validated = true;
					}
					else {
						for (let i in this.localPackageOptions) {
							if (this.localPackageOptions[i].code === item.code) {
								this.localPackageOptions[i].selected = true;
								this.alternateScreenComponent.updatedPrices();
							}
						}


						this.flag = this.localPackageCheck(item);
						if (this.flag) {
							this.selectedLocalPackageOptions.unshift(item);
						}
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;		
					    this.dataLoaderService.flagDictionary.validated = true;				
					    if(item.localPackagedEquipmentList === null || this.dataLoaderService.flagDictionary.alternateValidateFlag === false){
							this.commonDataService.progressBarColorFlag = true;
							if(this.commonDataService.progressBarColorFlag == true){
								setTimeout(() => {
								this.progressService.illuminateGreen();								
								}, 0);
							}
						}						
						this.savePackage();
					}
					this.sortingService.sortCodes(this.localPackageOptions,true)
					// for sorting
					this.sortingService.sortChecked(this.allPackageOptions)
					this.progressService.progressBarValidation();
				}, err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				});


		}
		else {
			for (let i in this.localPackageOptions) {
				if (this.localPackageOptions[i].code === item.code) {
					this.localPackageOptions[i].selected = true;
				}
			}
			this.flag = this.localPackageCheck(item);

			if (this.flag) {
				this.selectedLocalPackageOptions.unshift(item);
			}

			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.localPackageOptions,true)
			// for sorting
			this.sortingService.sortChecked(this.allPackageOptions)
			if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
				setTimeout(() => {
					this.progressService.illuminateGreen();
				}, 0);
			}
			this.savePackage();
		}
		this.progressService.progressBarValidation();


	}

	/**
	 * To uncheck the package option selected and splice it from the array 
	 * @param item of Data type
	 * @returns boolean value
	 */
	packageCheck(item): boolean {
		let index: number = -1;
		for (let j in this.packageOptions) {
			for (let i in this.selectedPackageOptions) {
				if ((item.code === this.selectedPackageOptions[i].code) && (item.code === this.packageOptions[j].code)) {
					this.packageOptions[j].selected = false;
					//Updated prices from validation response
					for (let s in this.dataLoaderService.gccUpdatedPrices) {
						for (let k in this.packageOptions) {
							if (this.packageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.packageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
								this.packageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
							}
						}
					}
					this.flag = false;
					this.selectedPackageOptions.splice(Number(i), 1);

					return this.flag;
				}
			}
			this.flag = true;
		}
		return this.flag;
	}
	/**
	 * To uncheck the local package selected and splice it from the array 
	 * @param item of Data type
	 * @returns boolean value
	 */
	localPackageCheck(item): boolean {
		let index: number = -1;
		for (let j in this.localPackageOptions) {
			for (let i in this.selectedLocalPackageOptions) {
				if ((item.code === this.selectedLocalPackageOptions[i].code) && (item.code === this.localPackageOptions[j].code)) {
					this.localPackageOptions[j].selected = false;
					//Updated prices from validation response
					for (let s in this.dataLoaderService.gccUpdatedPrices) {
						for (let k in this.localPackageOptions) {
							if (this.localPackageOptions[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.localPackageOptions[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
								this.localPackageOptions[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
							}
						}
					}

					this.commonDataService.deselectFlag = true;
					this.flag = false;
					this.selectedLocalPackageOptions.splice(Number(i), 1)
					return this.flag;
				}
			}
			this.flag = true;
		}
		return this.flag;
	}


	/**
	 * To send the selected package and local package option to the Summary screen and calculate the price accordingly
	 * @param none
	 * @returns none
	 */
	savePackage() {
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.selectedPackageOptions] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.selectedPackageOptions] });

		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.selectedLocalPackageOptions] });
		this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.selectedLocalPackageOptions] });

		this.priceCalculationService.normalModePriceCalculation();

	}

	/**
	 * To show the Package Equipment List present in the package 
	 * @param none
	 * @returns none
	 */
	viewDetails(item) {
		this.commonDataService.notifyPackageItem({ item });
	}


	openAlternateScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
		this.progressService.illuminateRed();
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.progressService.illuminateRed();
	}
	showViewDetails() {
		this.hideViewDetails = true;
	}
	showLocalViewDetails() {
		this.hideLocalViewDetails = true;
	}

	validate() {
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
		// this.summaryValidationComponent.alternateOptionsForURLFlag2Validate().then(()=>{
		// 	// this.calculateTotalPrice(); 
		// 	this.priceCalculationService.normalModePriceCalculation();
		// }).catch(()=>{
		// 	return
		// });
	}

	gotoNextTab() {
		if(this.isMarketCA_N()||this.isMarketCA_T()){
			this.commonDataService.notifyOther({ option: 'activeFactory' });
		}
		if(this.isMarketMX()){
			this.commonDataService.notifyOther({ option: 'activeRim' });
		}
	}

	isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
	}
	isMarketMX(){
		return Utils.isCountryMX(this.vehicleInfo.orderingMarket);
	}
	// for sorting
	selectOption(item){
		if((item.codeType == "PC" || item.codeType == "LI") && 
		item.standardType != "SE" && item.codeOwner == "M"){
			this.selectLocalPackageOption(item);
		}
		else if((item.codeType == "PC" || item.codeType == "LI") && 
		item.standardType != "SE" && item.codeOwner != "M"){
			this.selectPackageOption(item);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/package-options/package-options.component.ts